module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "game",
      "runningInApp": _vm.runningInApp
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('closeChangeName')
      }
    }
  }, [_vm._v("Play")]), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.changePlayerName = true
      }
    }
  })])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'help'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'highscore'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trophy",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showHighscore = true
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "status-bar"
  }, [_c('div', {
    staticClass: "players-online"
  }, [_vm._v("\n      " + _vm._s(_vm.clients) + "\n      "), _c('p', [_vm._v("Players online")])]), _vm._v(" "), _c('div', {
    staticClass: "games-played"
  }, [_vm._v("\n      " + _vm._s(_vm.totalGames) + "\n      "), _c('p', [_vm._v("Games played")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "game-version"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'changelog'
      }
    }
  }, [_vm._v(_vm._s(_vm.gameVersion))])], 1), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('div', [_c('span', [_vm._v("c")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("c")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("c")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("o")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("m")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("b")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("o")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/cccombogame/",
      "data-layout": "button_count",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-ad-client": "ca-pub-9072364747594224",
      "data-ad-slot": "3124355986",
      "data-ad-format": "auto"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31fc89cd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = 109
// module chunks = 1